
import UploadBankPaymentEntries from "../../BankPaymentEntry/UploadBankPaymentEntries";

const UploadBankPaymentEntriesPage = () => {
  return <UploadBankPaymentEntries />;
};

export default UploadBankPaymentEntriesPage;
